module.exports = __webpack_public_path__ + "static/media/icon.8c5d6012.png";